"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessPermissions = void 0;
var AccessPermissions;
(function (AccessPermissions) {
    AccessPermissions["NONE"] = "None";
    AccessPermissions["COMPANY_READ"] = "Company_Read";
    AccessPermissions["COMPANY_WRITE"] = "Company_Write";
    AccessPermissions["MEMBER_MANAGEMENT_READ"] = "MemberManagement_Read";
    AccessPermissions["MEMBER_MANAGEMENT_WRITE"] = "MemberManagement_Write";
    AccessPermissions["MSP"] = "Msp";
    AccessPermissions["WORKSPACE_REDIRECT"] = "Workspace_Redirect";
})(AccessPermissions || (exports.AccessPermissions = AccessPermissions = {}));
